module.exports = __webpack_public_path__ + "static/img/chaturbate.2f98730.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plataformas/chaturbate.svg
// module id = I4Vy
// module chunks = 1